export const WORKER_KEY = 'worker';
export const ACCESS_TOKEN_KEY = 'X-SpotgigWebAppToken';
export const UUID_KEY = 'uuid';
export const PLATFORM_TYPE_KEY = 'PLATFORM_TYPE';
export const CURRENT_STEP_KEY = 'currentStep';
